module.exports = __webpack_public_path__ + "media/empty-states/sponsors-e85bd998.png";